"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sentryInit = void 0;
const isProduction = process.env.NODE_ENV === 'production';
const sentryInit = async (_a) => {
    var { sentryDSN, user, environment, release } = _a, restProps = __rest(_a, ["sentryDSN", "user", "environment", "release"]);
    const Sentry = await Promise.resolve().then(() => __importStar(require('@sentry/browser')));
    if (!Sentry.getClient()) {
        Sentry.init(Object.assign({ dsn: sentryDSN, release: release || process.env.IMAGE_VERSION, environment: environment || process.env.ENV, tracesSampler: _samplingContext => {
                return !isProduction ? 0 : 0.05;
            }, beforeBreadcrumb(breadcrumb) {
                var _a;
                return ((_a = breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.data) === null || _a === void 0 ? void 0 : _a.url.includes('yandex')) ? null : breadcrumb;
            }, denyUrls: [
                // Chrome extensions
                /extensions\//i,
                /^chrome:\/\//i,
                /^chrome-extension:\/\//i,
            ] }, restProps));
        Sentry.setUser({ id: user ? user.sub : 'Не зарегистрирован' });
    }
};
exports.sentryInit = sentryInit;
